import { render, staticRenderFns } from "./VerticalMenu.vue?vue&type=template&id=7c6f7065&"
import script from "./VerticalMenu.vue?vue&type=script&lang=js&"
export * from "./VerticalMenu.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/themes/default/verticalmenu.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports